"use client";
import { Button } from "@/components/ui/button";
import { SOCIAL_LINK_ERROR_MESSAGES } from "@/constants";
import {
  Action,
  ControlType,
} from "@/context/AnalyticsProvider/AnalyticsProvider";
import { GamePageSection } from "@/context/AnalyticsProvider/gamePage";
import { useGameDetailsContext } from "@/context/GameDetailsContext";
import { useGameOnboardingContext } from "@/context/GameOnboardingContext";
import { useCallback, useEffect, useMemo } from "react";
import type { GPOnboardingStepProps } from "./utils";

export const LinkSteam = ({
  onNext,
  isVisible,
  track,
}: GPOnboardingStepProps) => {
  const { startSocialQuest, questState } = useGameOnboardingContext();
  const { allQuests, gameData } = useGameDetailsContext();
  const steamWishlistQuest = useMemo(
    () => allQuests.find((quest) => quest.type === "steam_wishlist"),
    [allQuests],
  );

  useEffect(() => {
    if (!isVisible) return;
    if (questState?.state === "connected") {
      track({
        action: Action.SUCCEEDED,
        extras: {
          control: "link-steam",
          section: GamePageSection.ONBOARDING_MODAL,
        },
      });
      onNext();
    }
  }, [questState, onNext, isVisible, track]);

  const handleClick = useCallback(() => {
    if (!steamWishlistQuest) return;
    startSocialQuest(gameData, steamWishlistQuest);
    track({
      action: Action.PRESSED,
      extras: {
        control: "link-steam",
        controlLabel: "Sign in with Steam",
        controlType: ControlType.BUTTON,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });
  }, [steamWishlistQuest, startSocialQuest, track, gameData]);

  useEffect(() => {
    if (!questState?.error) return;
    track({
      action: Action.FAILED,
      extras: {
        control: "link-steam",
        controlLabel: questState.error,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });
  }, [questState, track]);

  return (
    <div className="flex-grow flex flex-col items-center justify-between gap-y-10">
      {/* Title */}
      <div>
        <h2 className="text-[clamp(1.25rem,6.25vw,1.875rem)] font-bold leading-[clamp(1.5rem,6.25vw,2.25rem)] text-center">
          Link Steam account to upgrade to Silver Tier
        </h2>
      </div>

      {!questState?.error ? null : questState.error ===
        SOCIAL_LINK_ERROR_MESSAGES.SOCIAL_ACCOUNT_ALREADY_LINKED ? (
        <p className="text-sm text-red-500">
          {SOCIAL_LINK_ERROR_MESSAGES.SOCIAL_ACCOUNT_ALREADY_LINKED}
        </p>
      ) : (
        <p className="text-sm text-red-500">
          Something went wrong, please try again.
        </p>
      )}

      {/* Buttons */}
      <div className="flex flex-col items-center gap-y-10">
        <div className="flex flex-col items-center gap-y-3">
          <Button
            size="lg"
            className="h-12 px-6 rounded-[26px] text-lg font-medium shadow-[0px_1px_3px_0px_rgba(0,0,0,0.16),0px_1px_3px_0px_rgba(0,0,0,0.32)]"
            onClick={handleClick}
          >
            Sign in with Steam
          </Button>
          <p className="text-xs text-muted-foreground text-center">
            Note: Make sure your Steam profile is public to get verified.
          </p>
        </div>
        {/* <Button
          variant="ghost"
          size="lg"
          className="h-12 px-6 text-sm text-muted-foreground"
          onClick={onNext}
        >
          Not now
        </Button> */}
      </div>
    </div>
  );
};
